import React from 'react';
import TopMenu from './TopMenu';
import DialogMsgBox from './DialogMsgBox';

class Base extends React.Component {

	render() {
		return (
			<div>
				<main>
					{this.props.children}
				</main>
				<TopMenu />
				<DialogMsgBox />
			</div>
		)
	}
}

export default Base;



/** WEBPACK FOOTER **
 ** ./src/components/Base.jsx
 **/